const styles = {
  global: {
    "*:focus": {
      boxShadow: "none !important",
    },
    body: {
      color: "dark.dark",
    },
  },
};

export default styles;
